require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sommarkurs-i-relativitetsteori.json") })
        }
      }, "path---sommarkurs-i-relativitetsteori");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sommarkurs-i-relativitetsteori!./.cache/json/sommarkurs-i-relativitetsteori.json
// module id = 490
// module chunks = 231608221292675